<template>
  <!--
  fake page, only for finish static generation of the site without errors
  redirect to /documentation/... via nginx
   -->
</template>
